
export function hideHeaderElement(selector) {
    const layerMenu = document.querySelector(selector)
    const classList = layerMenu.classList

    if(classList.contains('d-none')) {
        classList.remove('d-none')
    } else {
        classList.add('d-none')
    }
}
